(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['app/feature-config/FeatureConfigModel', 'services/formFeatureConfigService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var formFeatureConfigService = require('./../urls').formFeatureConfigService;
    module.exports = factory(require('./../feature-config/FeatureConfigModel'), formFeatureConfigService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (FeatureConfigModel, formFeatureConfigService) {
  'use strict';

  /**
   * Model for form configuration information.
   * Uses the FormFeatureConfigService and corresponds to a FormFeatureConfig
   *
   * @class FormFeatureConfigModel
   * @extends FeatureConfigModel
   * @constructor
   */
  return new (FeatureConfigModel.extend({
    urlRoot: formFeatureConfigService
  }))();
}));
